const PATH = 'fe.components.certifications.test_card';

const messages = {
  attempts: {
    key: `${PATH}.attempts`,
    defaultValue: 'Up to 3 attempts'
  },
  subtitleHeader: {
    key: `${PATH}.subtitle_header`,
    defaultValue: 'Available until'
  },
  subtitle: {
    key: `${PATH}.subtitle`,
    defaultValue: '{{available_until}}'
  },
  goToAttempt: {
    key: `${PATH}.go_to_attempt`,
    defaultValue: 'Go to Attempt {{number}}'
  },
  goToAttemptAriaLabel: {
    key: `${PATH}.go_to_attempt_aria_label`,
    defaultValue: 'Go to Attempt {{number}} for {{name}}'
  },
  passed: {
    key: `${PATH}.passed`,
    defaultValue: 'Passed'
  },
  failed: {
    key: `${PATH}.failed`,
    defaultValue: 'Failed'
  },
  expired: {
    key: `${PATH}.expired`,
    defaultValue: 'Expired'
  },
  reportNumber: {
    key: `${PATH}.report_number`,
    defaultValue: 'Report {{number}}'
  },
  reportNumberAriaLabel: {
    key: `${PATH}.report_number_aria_label`,
    defaultValue: 'Report {{number}} for {{name}}'
  },
  noAttempts: {
    key: `${PATH}.no_attempts`,
    defaultValue: 'No attempts completed'
  },
  viewInstructions: {
    key: `${PATH}.view_instructions`,
    defaultValue: 'View Test Instructions'
  },
  viewInstructionsAriaLabel: {
    key: `${PATH}.view_instructions_aria_label`,
    defaultValue: 'View test instructions for {{name}}'
  }
};

export default messages;
